export const ConfigurationSettingsTabId = {
  ActivityLabels: 'activity-priorities',
  ActivityTypes: 'activity-types',
  Categories: 'requests-fields',
  FunctionalRoles: 'job-functions',
  Invoices: 'budget-plan',
  Salutations: 'salutation',
  TechnicalDetails: 'technical',
}
